import { Component } from "react"
import PropTypes from "prop-types"
import { WorksWithContent } from "./works_with_content"

import { compactInteger } from "humanize-plus"
import { connectionShape } from "app/lib/shared_prop_types"
import appletOrConnection from "shared/lib/use_applet_or_connection"
import userIconPng from "images/web/applet_card/user-icon.png"

import "./small_applet_card.scss"

export default class Meta extends Component {
  render() {
    const { mainService, applet } = this.props
    const humanizedInstallNumber = compactInteger(applet.installs_count, 1)
    const appletType = appletOrConnection(applet)

    return (
      <div className="meta">
        {applet.installs_count > 0 && (
          <div
            className="installs"
            aria-label={`${humanizedInstallNumber} users`}
            title={`${humanizedInstallNumber} users enabled this ${appletType}`}
          >
            <span className="verified">
              <img src={userIconPng} alt="user icon" loading="lazy" width="14" height="18" />
            </span>
            <span>{humanizedInstallNumber}</span>
          </div>
        )}
        <WorksWithContent applet={applet} mainService={mainService} />
      </div>
    )
  }
}

Meta.propTypes = {
  applet: connectionShape.isRequired,
  mainService: PropTypes.object,
}
